module.exports = __webpack_public_path__ + "img/kuaishou.c0836cfb.png";